import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { useI18n } from '@/src/hooks/useRouterChange';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { i18nGet } from '@/src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { get, isString } from 'lodash';
import React from 'react';
import { Button } from 'src/components/Antd';
import Link from 'src/components/Link/Link';
import ModalHoc from 'src/constrains/ModalHOC';
//import { getAreaCode } from 'src/request/common';
import { notifyAreaCode } from 'src/request/order';
import { msg } from 'src/tools/message';
import { EnumStatus } from 'src/types/common/common';
import { useGetAreaCodeText } from 'src/hooks/useGetAreaCodeText';
import VisibilityToggle from 'src/components/VisibilityToggle';
import Modal from './Editor';
import css from './css.module.less';
import {
  maskEmail,
  maskFirstName,
  maskLastName,
  maskPhone,
} from '@/src/tools/mask';

const permissions = () => {
  const edit_email_mobile = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.edit_email_mobile,
      }),
    ],
  });
  const resend_notification = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.resend_notification,
      }),
    ],
  });
  const view_order_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.AllOrders,
        operation: EnumOperation.view_order_details_page,
      }),
    ],
  });
  const view_edit_customer_info = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCustomer,
        operation: EnumOperation.view_edit_customer_info,
      }),
    ],
  });
  return {
    edit_email_mobile,
    resend_notification,
    view_order_details_page,
    view_edit_customer_info,
  };
};
const IssueInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [isVisible, setIsVisible] = React.useState(false);
  const {
    resend_notification,
    view_order_details_page,
    view_edit_customer_info,
  } = permissions();
  const { data, modalOp, onChange } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  // const [areaCodes, setAreaCodes] = React.useState([]);
  // React.useEffect(() => {
  //   getAreaCode().then((res) => {
  //     const area = Object.keys(res).map((i) => {
  //       return { label: res[i], value: i };
  //     });
  //     setAreaCodes(area);
  //     //console.log('res', res);
  //     //setAreaCodes(res);
  //   });
  // }, []);
  const uuid = get(data, 'uuid');
  const enableResend = get(data, 'status') === EnumStatus.Active;
  const sku = get(data, 'cardNo') || '-';
  const redeem = get(data, 'redemptionCode') || '-';
  const redeemInFootnote = isString(redeem)
    ? redeem === '-'
      ? '-'
      : redeem.length > 4
      ? redeem.slice(0, -4) + '****'
      : redeem.slice(0, -1) + '***'
    : '-';
  const orderNo = get(data, 'order.orderNo') || '-';
  const orderUuid = get(data, 'order.uuid') || '-';
  const usages = get(data, 'salesChannelUsages') || [];
  const usage = usages.length < 1 ? '-' : usages.map((i) => i.name).join(' ,');
  const databaseUuid = get(data, 'customer.customerDatabase.uuid');
  const customerUuid = get(data, 'customer.uuid');
  const sendToEmail = get(data, 'contact.email');
  const areaCode = get(data, 'contact.areaCodeInfo.uuid');
  const areaCodeInText = useGetAreaCodeText(areaCode);
  const mobile = get(data, 'contact.mobile');
  const status = get(data, 'status');
  const isActive = status === EnumStatus.Active;
  const firstNameFirst = get(
    data,
    'customer.customerDatabase.fullNameAutoPopulate.firstNameFirst',
    true,
  );
  const separatorList = { ['Space']: ' ', ['NotUse']: '', ['Comma']: ', ' };
  const separator =
    separatorList[
      get(
        data,
        'customer.customerDatabase.fullNameAutoPopulate.separator',
        'Space',
      )
    ];
  const firstName = isVisible
    ? get(data, 'customer.firstName') || ''
    : maskFirstName(get(data, 'customer.firstName') || '');
  const lastName = isVisible
    ? get(data, 'customer.lastName') || ''
    : maskLastName(get(data, 'customer.lastName') || '');

  const customer = firstNameFirst
    ? `${firstName}${separator}${lastName}`
    : `${lastName}${separator}${firstName}`;

  const contactRender = () => {
    const hasPhone = mobile && areaCodeInText;
    const hasEmail = !!sendToEmail;
    const mobilePhone =
      '+' +
      areaCodeInText +
      ' ' +
      (isVisible ? mobile : maskPhone(String(mobile), false));
    const basic = [];
    if (hasEmail) {
      basic.push({ text: isVisible ? sendToEmail : maskEmail(sendToEmail) });
    }
    if (hasPhone) {
      basic.push({ text: mobilePhone });
    }
    return basic;
  };
  const contact = get(data, 'contact');

  return (
    <SectionWrapper
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>
            {' '}
            {getI18n('giftCard.giftCardDetail.issueinfo_return_issue_title')}
          </span>
          <VisibilityToggle defaultVisible={false} onToggle={setIsVisible} />
        </div>
      }>
      <Line
        title={getI18n(
          'giftCard.giftCardDetail.issueinfo_return_cardnumber_title',
        )}
        contents={[{ text: sku }]}
      />
      <Line
        title={getI18n(
          'giftCard.giftCardDetail.issueinfo_return_redemption_title',
        )}
        contents={[{ text: redeemInFootnote }]}
      />
      <Line
        title={getI18n(
          'giftCard.giftCardDetail.issueinfo_return_ordernumber_title',
        )}
        contents={[
          {
            text: orderNo,
            path: view_order_details_page ? `/order/${orderUuid}` : '',
          },
        ]}
      />
      <Line
        title={getI18n(
          'giftCard.giftCardDetail.issueinfo_return_saleschannelUsage_title',
        )}
        contents={[{ text: usage }]}
      />
      <Line
        title={getI18n(
          'giftCard.giftCardDetail.issueinfo_return_customer_title',
        )}
        contents={[
          {
            text: customer,
            path: view_edit_customer_info
              ? `/customerDatabase/customerDetail/${databaseUuid}/${customerUuid}`
              : '',
          },
        ]}
      />
      <Line
        title={getI18n('giftCard.giftCardDetail.issueinfo_return_sendto_title')}
        contents={contactRender()}
        disabled={!isActive}
        onEdit={() => {
          setShowModal(true);
          setModalTitle(
            getI18n('giftCard.giftCardDetail.issueinfo_return_sendto_title'),
          );
          setModalContent(
            <Modal
              data={contact}
              uuid={uuid}
              onCancel={onModalCancel}
              onSubmit={(c) => {
                const _data = { ...data, contact: c };
                onChange(_data);
                onModalCancel();
              }}
            />,
          );
        }}
      />
      <Button
        onClick={() => {
          notifyAreaCode(uuid).then((res) => {
            msg.success(
              getI18n(
                'giftCard.giftCardDetail.issueinfo_return_btn_msgsuccess',
              ),
            );
          });
        }}
        disabled={!enableResend || !resend_notification}
        className={css.resendBtn}
        type='primary'>
        {getI18n('giftCard.giftCardDetail.resend')}
      </Button>
    </SectionWrapper>
  );
};
export default ModalHoc(IssueInfo);

const Line = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { edit_email_mobile } = permissions();

  const { title, contents, onEdit, disabled } = props;
  //const isLink = !!address;
  //console.log('onEdit', onEdit);
  const isNoData = (contents || []).length == 0;
  const contentRender = () => {
    return (contents || []).map((i, index, self) => {
      const { text, path } = i;
      const isLast = index === self.length - 1;
      const style = isLast ? { marginBottom: 0 } : {};
      if (path) {
        return (
          <RowContainer style={style} key={index}>
            <Link to={path} className={css.link}>
              {text}
            </Link>
          </RowContainer>
        );
      } else {
        return (
          <RowContainer style={style} key={index}>
            <div>{text}</div>
          </RowContainer>
        );
      }
    });
  };
  return (
    <div className={css.lineContainer}>
      <div className={css.title}>{title}</div>
      {isNoData ? '-' : <div>{contentRender()}</div>}
      {onEdit && edit_email_mobile && !disabled && (
        <div className={css.onEditBtn} onClick={onEdit}>
          {getI18n('general.edit')}
        </div>
      )}
    </div>
  );
};

const RowContainer = (props) => {
  const { style, children } = props;
  return (
    <div className={css.rowContainer} style={style}>
      {children}
    </div>
  );
};
